import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { CallHudComponent } from './call-hud.component';
import { TranslationIdMap } from './call-hud.i18n';

@NgModule({
    declarations: [CallHudComponent],
    exports: [CallHudComponent],
    imports: [
        CmpsButtonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsTeamsCallCallHudModule {}
